import { render, staticRenderFns } from "./FlotasCarousel.vue?vue&type=template&id=4809bd34&"
import script from "./FlotasCarousel.vue?vue&type=script&lang=ts&"
export * from "./FlotasCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./FlotasCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports